// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"5b8d9a18","661":"eb490906","895":"611ed2a8"}[chunkId] + ".chunk.js";
};